export const translations = {
  es: {
    // Navbar
    navHome: "Inicio",
    navServices: "Servicios",
    navGallery: "Galería",
    navAbout: "Sobre Nosotros",
    navMap: "Cobertura",
    navContact: "Contacto",
    language: "Idioma",
    backToHome: "Volver al Inicio",

    // Hero Section
    heroTitle: "UMTELKOMD: Expertos en Conectividad",
    heroSubtitle: "Más de 4 años de experiencia en soluciones avanzadas de fibra óptica y telecomunicaciones.",
    
    // Fiber Animation Labels
    fiberCentral: "Central",
    fiberPOP: "POP",
    fiberDistribucion: "Distribución",
    fiberCliente: "Cliente",


    // Services Section
    servicesTitle: "Nuestros Servicios",
    servicesSubtitle: "Nuestros servicios especializados en fibra óptica combinan precisión técnica y experiencia para garantizar soluciones de conectividad excepcionales.",
    service1Title: "Despliegue de Red de Fibra N3",
    service1Desc: "Especialistas en el despliegue de redes de fibra óptica nivel N3 (distribución). Nos encargamos de toda la infraestructura desde el nodo de distribución hasta los puntos de acceso.",
    service1Tasks: "• Instalación de cables de fibra óptica\n• Configuración de distribuidores\n• Empalmes y conexiones\n• Pruebas de atenuación\n• Documentación técnica",
    
    service2Title: "Despliegue de Red N4",
    service2Desc: "Implementación de redes de fibra óptica nivel N4 (acometida), conectando desde los puntos de distribución hasta el usuario final con máxima calidad.",
    service2Tasks: "• Acometidas hasta el hogar (FTTH)\n• Instalación de cajas terminales\n• Configuración de ONT\n• Pruebas de conectividad\n• Puesta en servicio",
    
    service3Title: "Atención de Averías",
    service3Desc: "Servicio técnico especializado en localización, diagnóstico y reparación de averías en redes de fibra óptica con tiempos de respuesta optimizados.",
    service3Tasks: "• Localización de averías con OTDR\n• Reparación de empalmes\n• Sustitución de cables dañados\n• Restauración del servicio\n• Informes técnicos detallados",
    
    service4Title: "Control y Gestión de Proyectos",
    service4Desc: "Gestión integral de proyectos de telecomunicaciones, desde la planificación hasta la entrega, asegurando calidad y cumplimiento de plazos.",
    service4Tasks: "• Planificación y coordinación\n• Supervisión técnica\n• Control de calidad\n• Gestión de recursos\n• Replanteos de viviendas\n• Documentación final",

    // Estadísticas de servicios
    stat1_1Label: "Fusiones realizadas",
    stat1_2Label: "Precisión",
    stat2_1Label: "Instalaciones",
    stat2_2Label: "Clientes satisfechos",
    stat3_1Label: "Cable soplado",
    stat3_2Label: "Más rápido",
    stat4_1Label: "Proyectos",
    stat4_2Label: "Red desplegada",
    stat5_1Label: "Averías resueltas",
    stat5_2Label: "Tiempo respuesta",
    stat7_1Label: "Proyectos completos",
    stat7_2Label: "Ahorro en costes",

    // Gallery Section
    galleryTitle: "Proyectos Destacados",
    gallerySubtitle: "Conoce nuestros trabajos más destacados en el campo de la fibra óptica",

    // About Section
    aboutTitle: "Sobre Nosotros",
    aboutSubtitle: "Conoce nuestra historia, misión y valores que nos definen como líderes en fibra óptica",
    aboutHistoryTitle: "Nuestra Trayectoria",
    aboutHistoryDesc: "Desde 2020 nos especializamos en despliegue de fibra óptica. Hemos crecido con cada proyecto, trabajando junto a empresas líderes del sector y adquiriendo una sólida experiencia técnica con visión clara hacia el futuro.",
    aboutMissionTitle: "Misión",
    aboutMissionDesc: "Soluciones de fibra óptica centradas en calidad y servicio personalizado. Acompañamos cada cliente desde la planificación hasta la implementación, garantizando resultados óptimos con un equipo técnico altamente capacitado.",
    aboutVisionTitle: "Visión",
    aboutVisionDesc: "Ser el proveedor de referencia en fibra óptica en Alemania. Crecimiento sostenible través de excelencia técnica y relaciones duraderas. Cada proyecto demuestra nuestra innovación y compromiso con la calidad.",

    // Contact Section
    contactTitle: "Contacto",
    contactSubtitle: "Estamos siempre disponibles para atender tus consultas y solicitudes",
    contactAddress: "Dirección",
    contactAddressValue: "Bassendorf 21, 18513 Deyelsdorf MV",
    contactPhone: "Teléfono de Oficina",
    contactPhoneValue: "038334-669952",
    contactEmail: "Correo Corporativo",
    contactEmailValue: "administration@umtelkomd.com",
    contactTechnical: "Soporte Técnico",
    contactTechnicalValue: "support@umtelkomd.com",

    // Map Section
    mapTitle: "Nuestros Proyectos",
    mapSubtitle: "Descubre las regiones de Alemania donde hemos implementado soluciones de fibra óptica",
    mapRegionsLabel: "Regiones",
    mapProjectsLabel: "Proyectos",
    mapClientsLabel: "Clientes",
    mapFiberBlownLabel: "Fibra Soplada",
    mapActivationsLabel: "Activaciones",
    mapSinceLabel: "Desde",
    mapCityLabel: "Ciudad Principal",
    mapYearStartedLabel: "Año de Inicio",
    mapStatusLabel: "Estado",
    mapStatusActive: "Activo",
    mapStatusCompleted: "Completado", 
    mapStatusPlanning: "En Planificación",
    mapLegendTitle: "Leyenda de Estados",
    mapKeyProjects: "Proyectos Clave",
    mapCoverageTitle: "Cobertura Internacional",
    mapCoverageDescription: "Trabajamos en múltiples países ofreciendo soluciones de fibra óptica de alta calidad.",
    mapGermanyTitle: "Alemania",
    mapGermanyDesc: "Mecklenburg-Vorpommern, Niedersachsen, Bayern, Nordrhein-Westfalen, Sachsen-Anhalt, Hessen",
    mapSpainTitle: "España", 
    mapSpainDesc: "Proyectos de expansión internacional en desarrollo",
    mapAustriaTitle: "Austria",
    mapAustriaDesc: "Colaboraciones estratégicas en infraestructura de telecomunicaciones",

    // Footer
    footerRights: "© 2024 UMTELKOMD. Todos los derechos reservados.",
    footerDeveloped: "Desarrollado por UTK IT",
    footerNewsletter: "Newsletter",
    footerSubscribe: "Suscríbete para recibir novedades",
    footerEmailPlaceholder: "Tu correo electrónico"
  },
  en: {
    // Navbar
    navHome: "Home",
    navServices: "Services",
    navGallery: "Gallery",
    navAbout: "About Us",
    navMap: "Coverage",
    navContact: "Contact",
    language: "Language",
    backToHome: "Back to Home",

    // Hero Section
    heroTitle: "UMTELKOMD: Connectivity Experts",
    heroSubtitle: "Over 4 years of experience in advanced fiber optic solutions and telecommunications.",
    
    // Fiber Animation Labels
    fiberCentral: "Central",
    fiberPOP: "POP",
    fiberDistribucion: "Distribution",
    fiberCliente: "Client",


    // Services Section
    servicesTitle: "Our Services",
    servicesSubtitle: "Our specialized fiber optic services combine technical precision and expertise to ensure exceptional connectivity solutions.",
    service1Title: "N3 Fiber Network Deployment",
    service1Desc: "Specialists in N3 level fiber optic network deployment (distribution). We handle all infrastructure from distribution nodes to access points.",
    service1Tasks: "• Fiber optic cable installation\n• Distributor configuration\n• Splicing and connections\n• Attenuation testing\n• Technical documentation",
    
    service2Title: "N4 Network Deployment", 
    service2Desc: "Implementation of N4 level fiber optic networks (drop), connecting from distribution points to end users with maximum quality.",
    service2Tasks: "• Fiber to the home (FTTH)\n• Terminal box installation\n• ONT configuration\n• Connectivity testing\n• Service commissioning",
    
    service3Title: "Fault Repair Service",
    service3Desc: "Specialized technical service for locating, diagnosing and repairing faults in fiber optic networks with optimized response times.",
    service3Tasks: "• OTDR fault location\n• Splice repair\n• Damaged cable replacement\n• Service restoration\n• Detailed technical reports",
    
    service4Title: "Project Control & Management",
    service4Desc: "Comprehensive telecommunications project management, from planning to delivery, ensuring quality and deadline compliance.",
    service4Tasks: "• Planning and coordination\n• Technical supervision\n• Quality control\n• Resource management\n• House surveys\n• Final documentation",

    // Service statistics
    stat1_1Label: "Splices completed",
    stat1_2Label: "Precision",
    stat2_1Label: "Installations",
    stat2_2Label: "Satisfied clients",
    stat3_1Label: "Cable blown",
    stat3_2Label: "Faster",
    stat4_1Label: "Projects",
    stat4_2Label: "Network deployed",
    stat5_1Label: "Issues resolved",
    stat5_2Label: "Response time",
    stat7_1Label: "Complete projects",
    stat7_2Label: "Cost savings",

    // Gallery Section
    galleryTitle: "Featured Projects",
    gallerySubtitle: "Discover our most outstanding works in the field of fiber optics",

    // About Section
    aboutTitle: "About Us",
    aboutSubtitle: "Learn about our history, mission and values that define us as leaders in fiber optics",
    aboutHistoryTitle: "Our Journey",
    aboutHistoryDesc: "Since 2020, we specialize in fiber optic deployment. We've grown with each project, working alongside industry leaders and acquiring solid technical expertise with a clear vision for the future.",
    aboutMissionTitle: "Mission",
    aboutMissionDesc: "Fiber optic solutions focused on quality and personalized service. We support each client from planning to implementation, ensuring optimal results with our highly trained technical team.",
    aboutVisionTitle: "Vision",
    aboutVisionDesc: "To be the leading fiber optic provider in Germany through sustainable growth, technical excellence and lasting relationships. Each project demonstrates our innovation and commitment to quality.",
    aboutCertificationTitle: "Certifications",
    aboutCertificationDesc: "We have all necessary certifications for fiber optic installations according to international standards, ISO 9001 and ITU-T recommendations. Our technical staff receives continuous training to stay at the forefront.",

    // Contact Section
    contactTitle: "Contact",
    contactSubtitle: "We are always available to address your inquiries and requests",
    contactAddress: "Address",
    contactAddressValue: "Bassendorf 21, 18513 Deyelsdorf MV, Germany",
    contactPhone: "Office Phone",
    contactPhoneValue: "038334-669952",
    contactEmail: "Corporate Email",
    contactEmailValue: "administration@umtelkomd.com",
    contactTechnical: "Technical Support",
    contactTechnicalValue: "support@umtelkomd.com",

    // Map Section
    mapTitle: "Our Projects",
    mapSubtitle: "Discover the regions in Germany where we have implemented fiber optic solutions",
    mapRegionsLabel: "Regions",
    mapProjectsLabel: "Projects",
    mapClientsLabel: "Clients",
    mapFiberBlownLabel: "Fiber Blown",
    mapActivationsLabel: "Activations",
    mapSinceLabel: "Since",
    mapCityLabel: "Main City",
    mapYearStartedLabel: "Year Started",
    mapStatusLabel: "Status",
    mapStatusActive: "Active",
    mapStatusCompleted: "Completed",
    mapStatusPlanning: "In Planning",
    mapLegendTitle: "Status Legend",
    mapKeyProjects: "Key Projects",
    mapCoverageTitle: "International Coverage",
    mapCoverageDescription: "We work across multiple countries providing high-quality fiber optic solutions.",
    mapGermanyTitle: "Germany",
    mapGermanyDesc: "Mecklenburg-Vorpommern, Niedersachsen, Bayern, Nordrhein-Westfalen, Sachsen-Anhalt, Hessen",
    mapSpainTitle: "Spain",
    mapSpainDesc: "International expansion projects in development",
    mapAustriaTitle: "Austria", 
    mapAustriaDesc: "Strategic collaborations in telecommunications infrastructure",

    // Footer
    footerRights: "© 2024 UMTELKOMD. All rights reserved.",
    footerDeveloped: "Developed by UTK IT",
    footerNewsletter: "Newsletter",
    footerSubscribe: "Subscribe to receive updates",
    footerEmailPlaceholder: "Your email address"
  },
  de: {
    // Navbar
    navHome: "Startseite",
    navServices: "Dienstleistungen",
    navGallery: "Galerie",
    navAbout: "Über Uns",
    navMap: "Abdeckung",
    navContact: "Kontakt",
    language: "Sprache",
    backToHome: "Zurück zur Startseite",

    // Hero Section
    heroTitle: "UMTELKOMD: Ihr Partner für Glasfaser",
    heroSubtitle: "Seit über 4 Jahren setzen wir auf modernste Glasfasertechnologie und zuverlässige Telekommunikationslösungen.",
    
    // Fiber Animation Labels
    fiberCentral: "Zentrale",
    fiberPOP: "POP",
    fiberDistribucion: "Verteilung",
    fiberCliente: "Kunde",


    // Services Section
    servicesTitle: "Unsere Dienstleistungen",
    servicesSubtitle: "Mit technischer Präzision und jahrelanger Erfahrung bieten wir maßgeschneiderte Glasfaserlösungen für eine perfekte Vernetzung.",
    service1Title: "N3 Glasfasernetz-Ausbau",
    service1Desc: "Wir sind spezialisiert auf den professionellen Ausbau von N3-Glasfasernetzen. Von der Verteilungsebene bis zu den Zugangspunkten kümmern wir uns um Ihre komplette Netzinfrastruktur.",
    service1Tasks: "• Präzise Installation von Glasfaserkabeln\n• Fachgerechte Konfiguration der Verteiler\n• Professionelles Spleißen und Verbinden\n• Genaue Dämpfungsmessungen\n• Vollständige technische Dokumentation",
    
    service2Title: "N4 Netzwerk-Ausbau",
    service2Desc: "Von den Verteilerpunkten direkt zu Ihnen nach Hause - wir sorgen für den zuverlässigen N4-Glasfaseranschluss mit höchster Qualität und Geschwindigkeit.",
    service2Tasks: "• Glasfaser direkt ins Haus (FTTH)\n• Montage der Anschlussboxen\n• Konfiguration der ONT-Geräte\n• Umfassende Verbindungstests\n• Komplette Inbetriebnahme",
    
    service3Title: "Störungsbehebung",
    service3Desc: "Wenn's mal nicht läuft, sind wir da! Unser Expertenteam lokalisiert und behebt Störungen in Ihrem Glasfasernetz schnell und zuverlässig.",
    service3Tasks: "• Präzise Störungsortung mit OTDR\n• Fachgerechte Spleißreparaturen\n• Schneller Austausch defekter Kabel\n• Zügige Wiederherstellung des Services\n• Ausführliche technische Berichte",
    
    service4Title: "Projektmanagement & Kontrolle",
    service4Desc: "Von der ersten Idee bis zur finalen Übergabe - wir begleiten Ihre Telekommunikationsprojekte professionell und termingerecht.",
    service4Tasks: "• Durchdachte Planung und Koordination\n• Kontinuierliche technische Betreuung\n• Strenge Qualitätskontrolle\n• Effiziente Ressourcenverwaltung\n• Hausbehung\n• Komplette Projektdokumentation",

    // Service statistics
    stat1_1Label: "Durchgeführte Spleißungen",
    stat1_2Label: "Präzision",
    stat2_1Label: "Installationen",
    stat2_2Label: "Zufriedene Kunden",
    stat3_1Label: "Eingeblasenes Kabel",
    stat3_2Label: "Schneller",
    stat4_1Label: "Projekte",
    stat4_2Label: "Verlegtes Netzwerk",
    stat5_1Label: "Gelöste Störungen",
    stat5_2Label: "Reaktionszeit",
    stat7_1Label: "Abgeschlossene Projekte",
    stat7_2Label: "Kosteneinsparungen",

    // Gallery Section
    galleryTitle: "Ausgewählte Projekte",
    gallerySubtitle: "Entdecken Sie unsere herausragendsten Arbeiten im Bereich der Glasfasertechnik",

    // About Section
    aboutTitle: "Über Uns",
    aboutSubtitle: "Lernen Sie unser Team kennen - unsere Werte und die Vision, die uns täglich antreibt",
    aboutHistoryTitle: "Unser Weg",
    aboutHistoryDesc: "Seit 2020 bringen wir Glasfasertechnologie genau dorthin, wo sie gebraucht wird. Mit jedem Projekt entwickeln wir uns weiter und bauen durch die enge Zusammenarbeit mit Branchenführern sowohl unser technisches Know-how als auch unser Verständnis für Kundenwünsche stetig aus.",
    aboutMissionTitle: "Unsere Mission",
    aboutMissionDesc: "Menschen und modernste Technologie zu verbinden - das ist unser Auftrag. Mit individuellen Glasfaserlösungen schaffen wir das Fundament für eine vernetzte Zukunft. Persönlicher Service steht dabei immer im Mittelpunkt, von der ersten Beratung bis zur finalen Inbetriebnahme.",
    aboutVisionTitle: "Unsere Vision",
    aboutVisionDesc: "Wir möchten der erste Ansprechpartner für Glasfaserlösungen in Deutschland werden - nicht durch große Versprechen, sondern durch zuverlässige Arbeit und echte Innovationskraft. In jedem Projekt zeigen wir, was entstehen kann, wenn Fachwissen auf Leidenschaft trifft.",
    aboutCertificationTitle: "Zertifizierungen",
    aboutCertificationDesc: "Wir verfügen über alle erforderlichen Zertifizierungen für Glasfaserinstallationen gemäß internationalen Standards, ISO 9001 und ITU-T-Empfehlungen. Unser technisches Personal erhält kontinuierliche Schulungen, um an der Spitze zu bleiben.",

    // Contact Section
    contactTitle: "Kontakt",
    contactSubtitle: "Wir stehen Ihnen jederzeit für Ihre Anfragen und Wünsche zur Verfügung",
    contactAddress: "Adresse",
    contactAddressValue: "Bassendorf 21, 18513 Deyelsdorf MV, Deutschland",
    contactPhone: "Bürotelefon",
    contactPhoneValue: "038334-669952",
    contactEmail: "Unternehmens-E-Mail",
    contactEmailValue: "administration@umtelkomd.com",
    contactTechnical: "Technischer Support",
    contactTechnicalValue: "support@umtelkomd.com",

    // Map Section
    mapTitle: "Unsere Projekte",
    mapSubtitle: "Entdecken Sie die Regionen in Deutschland, in denen wir Glasfaserlösungen umgesetzt haben",
    mapRegionsLabel: "Regionen",
    mapProjectsLabel: "Projekte",
    mapClientsLabel: "Kunden",
    mapFiberBlownLabel: "Eingeblasene Faser",
    mapActivationsLabel: "Aktivierungen",
    mapSinceLabel: "Seit",
    mapCityLabel: "Hauptstadt",
    mapYearStartedLabel: "Startjahr",
    mapStatusLabel: "Status",
    mapStatusActive: "Aktiv",
    mapStatusCompleted: "Abgeschlossen",
    mapStatusPlanning: "In Planung",
    mapLegendTitle: "Status-Legende",
    mapKeyProjects: "Schlüsselprojekte",
    mapCoverageTitle: "Internationale Abdeckung", 
    mapCoverageDescription: "Wir arbeiten in mehreren Ländern und bieten hochwertige Glasfaserlösungen an.",
    mapGermanyTitle: "Deutschland",
    mapGermanyDesc: "Mecklenburg-Vorpommern, Niedersachsen, Bayern, Nordrhein-Westfalen, Sachsen-Anhalt, Hessen",
    mapSpainTitle: "Spanien",
    mapSpainDesc: "Internationale Expansionsprojekte in Entwicklung", 
    mapAustriaTitle: "Österreich",
    mapAustriaDesc: "Strategische Kooperationen in der Telekommunikationsinfrastruktur",

    // Footer
    footerRights: "© 2024 UMTELKOMD. Alle Rechte vorbehalten.",
    footerDeveloped: "Entwickelt von UTK IT",
    footerNewsletter: "Newsletter",
    footerSubscribe: "Abonnieren Sie, um Updates zu erhalten",
    footerEmailPlaceholder: "Ihre E-Mail-Adresse"
  },
}; 